import React, { useEffect, useState } from "react";
import notify from "../Notifcation";
const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Listen for the 'beforeinstallprompt' event
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the default mini-infobar from appearing
      e.preventDefault();
      // Save the event to trigger it later
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      // Show the install prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
        } else {
        }
        // Clear the deferred prompt
        setDeferredPrompt(null);
      });
    } else {
      notify("لقد تم تحميل التطبيق لديك ", "warn");
      return;
    }
  };

  return (
    <div>
      <div
        className="mt-4 mb-2 text-center"
        style={{ fontSize: "17px", cursor: "pointer", color: "blue" }}
        onClick={handleInstallClick}>
        <img
          src="a3maal.png"
          alt=""
          style={{ width: "53px", borderRadius: "41%", objectFit: "contain" }}
        />
        <i className="fa-solid fa-download"></i> تحميل أجندة المحامي القضائية
      </div>
    </div>
  );
};

export default InstallPWAButton;
